import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/rolefeatures/RoleFeatures.vue'),
		meta: {
			title: 'ruoli',
			acl: 'section.ruoli'
		}
	}
];

export default routes;